import React from "react";
import styled from "styled-components";
import mainBcg from "../images/5.jpg";
import SocialLinks from "./SocialLinks";

export default function Hero({ img, title, max, children, mouse }) {
  return (
    <HeroWrapper max={max} img={img} mouse={mouse}>
      <div className="banner">
        <h1 className="title">{title}</h1>
        {children}
      </div>
      <SocialLinks />
      <div class="middle">
        <div class="mouse"></div>
      </div>
    </HeroWrapper>
  );
}

const HeroWrapper = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${(props) => (props.max ? "100vh" : "70vh")};
  color: var(--mainWhite);
  background: linear-gradient(var(--primaryRGBA), var(--primaryRGBA)),
    url(${(props) => props.img}) center/cover no-repeat;
  border-radius: 0 0 85% 85% / 30%;
  .title {
    padding-top: 2rem;
    margin-bottom: 50px;
    font-size: 3.5rem;
    text-shadow: 4px 4px 2px rgba(0, 0, 0, 0.3);
    text-transform: uppercase;
    letter-spacing: var(--mainSpacing);
  }
  .middle {
    display: ${(props) => (props.mouse ? "block" : "none")};
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .mouse {
    width: 30px;
    height: 50px;
    border: 2px solid #fff;
    border-radius: 60px;
  }
  .mouse {
    &:before {
      content: "";
      width: 8px;
      height: 8px;
      position: absolute;
      top: 10px;
      background: #fff;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 50%;
      opacity: 1;
      animation: mouse 1.5s infinite;
    }
  }
  @keyframes mouse {
    from {
      opacity: 1;
      top: 10px;
    }
    to {
      opacity: 0;
      top: 40px;
    }
  }
`;

Hero.defaultProps = {
  img: mainBcg,
};
